export default __webpack_public_path__ + "static/media/arrow-down.b6cecafb.svg";